/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Tooltip, Radio, Modal, Mentions, Spin, Tag, Typography,Popover,QRCode,Badge } from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import { hnrequest } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';
// import axios from 'axios';




const { Paragraph, Text } = Typography;

const optionsWithDisabled = [
  {
    label: '需要',
    value: 'Y',
  },
  {
    label: '不需要',
    value: 'N',
  }
];

const Dbr = () => {
  const [tdown] = Form.useForm();
  const [spinning, setSpinning] = useState(false);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息

  const [open, setOpen] = useState(false);
  const [bangm, setbangm] = useState([]);
  const [ticks, setticks] = useState([]);// ticks



  const toDown = (e) => { // 数据下载
    false && setSpinning(true)
    setOpen(false)
    const xzurl = "https://webapi.ddspp.com:30126/v2/dbdown_txt";

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = xzurl;
    form.target = '_blank';

    const data = {
      dbno: e.dbno,
      fushu: '1',
      DBM: "Y",
      DBY: e.yzcode === undefined ? "N" : e.yzcode,
      DBF: e.jqbm === undefined ? "N" : e.jqbm,
      DBX: e.dblis === undefined ? "N" : e.dblis
    };

    for (const key in data) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    form.remove();

    setTimeout(() => { setticks(e.dbno) }, 3000);




    // const dbd = await hnrequest.post('/pdbdown', e)




    // if (dbd.return_code) { setSpinning(false) }
    // if ((e.email === "" | e.email === undefined) && dbd.return_code === "success") {
    //   setticks(dbd.ticks)
    //   window.open(dbd.turl, "_blank")
    // }   //没填写邮箱,直接返回下载链接
    // if ((e.email === "" | e.email === undefined) && dbd.return_code === "F") { message.error(dbd.return_msg) }  //没填写邮箱,直接返回下载链接

    // if ((e.email !== "" && e.email !== undefined) && dbd.return_code === "F") { message.error(dbd.return_msg) } //填写邮箱,返回处理结果
    // if ((e.email !== "" && e.email !== undefined) && dbd.return_code === "success") {
    //   setticks(dbd.ticks)
    //   message.success(dbd.return_msg)
    // } //填写邮箱,返回处理结果

  }


  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/pdb_list', { dbsj: 'd2' })
      setbangm(res.rescode)
    }

    getau()

  }, [ticks])


  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const ppth = (e) => {
    setOpen(true)
    setccpxx(e)
    tdown.setFieldsValue({ dbno: e.key })

  }


  const columns = [{
    title: '数据批号',
    dataIndex: 'key',
    key: 'key',
    sorter: (a, b) => a.key - b.key,
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => (
      <Space size="middle">
        {record.key}
      </Space>
    ),

  },
  {
    title: '类型',
    dataIndex: 'plb',
    key: 'plb',
    render: (_, record) => (
      <Space size="small">
        {record.dblx === "outdb" && <Tag color="#108ee9" >Group</Tag>}
        {record.dblx === "indb" && <Tag color="#87d068" >Single</Tag>}
        {record.plb === "1001" && <Tag color="volcano" >农药</Tag>}
        {record.plb === "1003" && <Tag color="green" >种子</Tag>}
        {record.plb === "1002" && <Tag color="purple" >农肥&其他</Tag>}
        {record.plb === "1004" && <Tag color="purple" >农肥&其他</Tag>}
      </Space>
    ),
  },
  {
    title: '产品名称',
    key: 'pname',
    ...getColumnSearchProps('pname'),
    dataIndex: 'pname',
    render: (_, record) => (
      <Popover content={<QRCode value={ record.bmgz==="2023"?`${record.zs_url}?q=${record.demo}`:`http://ddspp.cn/${record.dblx==="indb"?"S":"G"}/${record.demo}`  } bordered={false} size='118' />} >
        
        <Badge count='预览' offset={[26, 0]} color='green'>{record.pname}</Badge>
        </Popover>
    ),


  },
  {
    title: '规格',
    dataIndex: 'g_ms',
    key: 'g_ms',
    ...getColumnSearchProps('g_ms'),
  },

  {
    title: '生成时间',
    dataIndex: 'scsj',
    key: 'scsj',
    ...getColumnSearchProps('scsj'),
    render: (_, record) => (<Popover  content={<Space orientation="vertical" size='small' ><Text>生成时间:{record.dstime} </Text><Text>数量：{record.db_total} </Text><Text>下载次数:{record.db_ds}</Text></Space>} color="blue" key={`scsj${record.key}`}>{record.scsj}</Popover >),
  },
  {
    title: '创建者',
    key: 'key',
    ...getColumnSearchProps('key'),
    render: () => (
      <Space size="small">-
      </Space>
    ),

  },
  {
    title: '数量',
    dataIndex: 'db_total',
    key: 'db_total',
  },
  {
    title: '下载次数',
    dataIndex: 'db_ds',
    key: 'db_ds',
  },
  {
    title: "",
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <Tooltip title="数据下载" ><Button type="primary" size="small" icon={<DownloadOutlined />}
          // id={record.key} 
          onClick={() => ppth(record)}>数据下载</Button></Tooltip>
      </Space>
    ),
  },
  ];


  const [form] = Form.useForm();
  return (
    <>


      <ConfigProvider locale={zhCN}   theme={{
                components: {
                  Table: {
                    rowHoverBg: '#7ed3be',          // 鼠标高亮背景
                    rowSelectedHoverBg: '#7ed3be',  // 选中行 hover 背景
                  },
                },
              }}  >




        <Form form={form} component={false}>

          <Table size="small"
            // rowSelection={   {type:"checkbox",...rowSelection,}} 
            columns={columns} dataSource={bangm} />

        </Form>



        <Modal
          // title="数据信息"
          centered
          open={open}
          footer={false}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
        >
          <Form form={tdown} onFinish={toDown} >

            <Paragraph>产品名称:{ccpxx.pname}  <Text>数据批号:{ccpxx.key}</Text> </Paragraph>

            <Form.Item name="dbno" hidden="true"><Input /></Form.Item>

            <Form.Item label="接收邮箱" name="email"
            >
              <Mentions
                style={{
                  width: '100%',
                }}
                split=''
                options={[
                  { value: 'qq.com', label: 'qq.com', },
                  { value: '163.com', label: '163.com', },
                  { value: '126.com', label: '126.com', },
                  { value: 'sina.com', label: 'sina.com', },
                  { value: 'yeah.net', label: 'yeah.net', },
                  { value: '188.com', label: '188.com', },
                  { value: 'vip.163.com', label: 'vip.163.com', },
                  { value: 'vip.126.com', label: 'vip.126.com', },

                ]}
              />


            </Form.Item>


            <Space.Compact>
              <Space>

                <Form.Item label="单次序号" name="dblis"
                >
                  <Radio.Group
                    options={optionsWithDisabled}
                    defaultValue="N"
                    optionType="button"
                    buttonStyle="solid"

                  />


                </Form.Item>

                <Form.Item label="验证码" name="yzcode"
                >
                  <Radio.Group
                    options={optionsWithDisabled}
                    defaultValue="N"
                    optionType="button"
                    buttonStyle="solid"
                  />


                </Form.Item>
              </Space>
            </Space.Compact>
            <Space.Compact>
              <Space>

                <Form.Item label="鉴权编码" name="jqbm"
                >
                  <Radio.Group
                    options={optionsWithDisabled}
                    defaultValue="N"
                    optionType="button"
                    buttonStyle="solid"
                  />


                </Form.Item>


              </Space>




            </Space.Compact>














            <Form.Item >
              <Button type="primary" htmlType="submit">
                提 交
              </Button>
            </Form.Item>

          </Form>




        </Modal>





        <Spin spinning={spinning} description="数据整理中，请稍等..." fullscreen />

      </ConfigProvider>
    </>

  );
};
export default Dbr;